import { useHistory } from 'react-router';
import { selectors } from '~/store/state-selectors';
import { useStoreActions, useStoreStatic } from '~/store/store-context';
import { useOnMount } from './useOnMount';
export function useManageLocationStack(param) {
    let { initialLocations } = param;
    const history = useHistory();
    const { setLocationStack } = useStoreActions();
    const { getState } = useStoreStatic();
    useOnMount(()=>{
        setLocationStack(initialLocations);
        history.listen((location, action)=>{
            const currentLocationStack = selectors.locationStack(getState());
            switch(action){
                case 'PUSH':
                    setLocationStack([
                        ...currentLocationStack,
                        location
                    ]);
                    break;
                case 'REPLACE':
                    setLocationStack([
                        ...currentLocationStack.slice(0, -1),
                        location
                    ]);
                    break;
                case 'POP':
                    setLocationStack(currentLocationStack.slice(0, -1));
                    break;
            }
        });
    });
}
